import { API_FAILED, CLEAR_API_ERROR } from 'src/redux/Actions/Type';

export const setGlobalError = (error) => {
  const statusCode = error?.response?.status || error?.status;
  let message = error?.message,
    errorList = error?.response?.data || {};

  if (!message) {
    message = statusCode
      ? `Error ${statusCode}: Something went wrong`
      : 'Something went wrong';
  }

  if (Object.keys(errorList)?.length === 0) {
    errorList = {
      info: [
        statusCode
          ? `The server returned status ${statusCode}, but no additional details were provided.`
          : 'No additional error details were provided by the server.',
      ],
    };
  }

  return {
    type: API_FAILED,
    payload: {
      id: Date.now(),
      message,
      errorList,
    },
  };
};

export const clearGlobalError = (id) => ({
  type: CLEAR_API_ERROR,
  payload: { id },
});
